<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col">
          <p class="title">Con fecha de {{ revisionFecha }} a las {{ revisionFechaHora }}, se realizó la revisión de
            solicitud pendiente,
            con la siguiente información:</p>
        </div>
      </div>
      <div class="row">
        <template v-if="media.sm">
          <div class="col-md-12">
            <el-descriptions :column="1" border direction="vertical" >
              <el-descriptions-item content-class-name="pp-el-descriptions-item">
                <template slot="label">
                  <span class="el-icon-bell"></span>
                  Estado de revisión
                </template>
                <el-tag :type="estadoTag" data-cy="review-state">{{ estadoRevision }}</el-tag>
              </el-descriptions-item>
              <template v-if="estadoRevisionCodigo === 2">
                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-date"></span>
                    Plazo máximo para reclamar
                  </template>
                  <span data-cy="review-max-date">{{ fechaMaxima }}</span>
                </el-descriptions-item>

                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-scissors"></span>
                    Motivos de Rechazo
                  </template>
                  <el-tag type="primary" data-cy="reffuse">{{ motivoRechazo }}</el-tag>
                </el-descriptions-item>

                <template v-if="motivoRechazoCodigo === 4">
                  <el-descriptions-item content-class-name="pp-el-descriptions-item">
                    <template slot="label">
                      <span class="el-icon-tickets"></span>
                      Descripción del motivo de Rechazo
                    </template>
                    <span data-cy="reffuse-description">{{ descripcionRechazo }}</span>
                  </el-descriptions-item>
                </template>

                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-document"></span>
                    Instancia del reclamo
                  </template>
                  <span data-cy="review-instance">{{ instancia }}</span>
                </el-descriptions-item>
              </template>
            </el-descriptions>
          </div>
        </template>
        <template v-else>
          <div :class="estadoRevisionCodigo === 2 ? 'col' : 'col-md-4'">
            <el-descriptions :column="estadoRevisionCodigo === 2 ? 4 : 1" border>
              <el-descriptions-item content-class-name="pp-el-descriptions-item" span="3">
                <template slot="label">
                  <span class="el-icon-bell"></span>
                  Estado de revisión
                </template>
                <el-tag :type="estadoTag" data-cy="review-state">{{ estadoRevision }}</el-tag>
              </el-descriptions-item>
              <template v-if="estadoRevisionCodigo === 2">
                <el-descriptions-item content-class-name="pp-el-descriptions-item">
                  <template slot="label">
                    <span class="el-icon-date"></span>
                    Plazo máximo para reclamar
                  </template>
                  <span data-cy="review-max-date">{{ fechaMaxima }}</span>
                </el-descriptions-item>

                <el-descriptions-item content-class-name="pp-el-descriptions-item" span="4">
                  <template slot="label">
                    <span class="el-icon-scissors"></span>
                    Motivos de Rechazo
                  </template>
                  <el-tag type="primary" data-cy="reffuse">{{ motivoRechazo }}</el-tag>
                </el-descriptions-item>

                <template v-if="motivoRechazoCodigo === 4">
                  <el-descriptions-item content-class-name="pp-el-descriptions-item" span="4">
                    <template slot="label">
                      <span class="el-icon-tickets"></span>
                      Descripción del motivo de Rechazo
                    </template>
                    <span data-cy="reffuse-description">{{ descripcionRechazo }}</span>
                  </el-descriptions-item>

                </template>

                <el-descriptions-item content-class-name="pp-el-descriptions-item" span="4">
                  <template slot="label">
                    <span class="el-icon-document"></span>
                    Instancia del reclamo
                  </template>
                  <span data-cy="review-instance">{{ instancia }}</span>
                </el-descriptions-item>
              </template>
            </el-descriptions>

          </div>
        </template>

      </div>
    </div>
  </div>

</template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {Descriptions, DescriptionsItem, Link, Tag} from "element-ui";

export default {
  name: "RevisionSolicitudVer",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
    [Link.name]: Link,
  },
  props: {
    revisionFecha: String,
    revisionFechaHora: String,
    estadoRevisionCodigo: Number,
    estadoRevision: String,
    motivoRechazoCodigo: Number,
    motivoRechazo: String,
    listaRechazo: Array,
    descripcionRechazo: String,
    instancia: String,
    fechaMaxima: String,
    disabled: {
      type: Boolean,
      default: true
    }
  },
  mixins: [ScreenSizeMixin],
  computed: {
    estadoTag() {
      return this.estadoRevisionCodigo === 1 ? 'success' : 'danger'
    }
  }
}
</script>
